export const PrimeNGTranslationConstant = {
  startsWith: "Começa com",
  contains: "Contém",
  notContains: "Não contém",
  endsWith: "Termina com",
  equals: "Igual",
  notEquals: "Diferente",
  noFilter: "Sem Filtro",
  filter: "Filtro",
  lt: "Menor que",
  lte: "Menor ou igual a",
  gt: "Maior que",
  gte: "Maior ou igual a",
  dateIs: "Data é",
  dateIsNot: "Data não é",
  dateBefore: "Data antes de",
  dateAfter: "Data depois de",
  custom: "Personalizado",
  clear: "Limpar",
  apply: "Aplicar",
  matchAll: "Corresponder Todos",
  matchAny: "Corresponder Qualquer",
  addRule: "Adicionar Regra",
  removeRule: "Remover Regra",
  accept: "Sim",
  reject: "Não",
  choose: "Escolher",
  upload: "Enviar",
  cancel: "Cancelar",
  completed: "Concluído",
  pending: "Pendente",
  fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
  dayNames: [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
  ],
  dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
  dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
  monthNames: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],
  monthNamesShort: [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ],
  chooseYear: "Escolher Ano",
  chooseMonth: "Escolher Mês",
  chooseDate: "Escolher Data",
  prevDecade: "Década Anterior",
  nextDecade: "Próxima Década",
  prevYear: "Ano Anterior",
  nextYear: "Próximo Ano",
  prevMonth: "Mês Anterior",
  nextMonth: "Próximo Mês",
  prevHour: "Hora Anterior",
  nextHour: "Próxima Hora",
  prevMinute: "Minuto Anterior",
  nextMinute: "Próximo Minuto",
  prevSecond: "Segundo Anterior",
  nextSecond: "Próximo Segundo",
  am: "AM",
  pm: "PM",
  today: "Hoje",
  now: "Agora",
  weekHeader: "Sem",
  firstDayOfWeek: 0,
  showMonthAfterYear: false,
  dateFormat: "dd/mm/yy",
  weak: "Fraco",
  medium: "Médio",
  strong: "Forte",
  passwordPrompt: "Digite uma senha",
  emptyFilterMessage: "Nenhum resultado encontrado",
  searchMessage: "Existem {0} resultados disponíveis",
  selectionMessage: "{0} itens selecionados",
  emptySelectionMessage: "Nenhum item selecionado",
  emptySearchMessage: "Nenhum resultado encontrado",
  emptyMessage: "Nenhuma opção disponível",
  aria: {
    trueLabel: "Verdadeiro",
    falseLabel: "Falso",
    nullLabel: "Não Selecionado",
    star: "1 estrela",
    stars: "{star} estrelas",
    selectAll: "Todos os itens selecionados",
    unselectAll: "Todos os itens desmarcados",
    close: "Fechar",
    previous: "Anterior",
    next: "Próximo",
    navigation: "Navegação",
    scrollTop: "Rolar para o Topo",
    moveTop: "Mover para o Topo",
    moveUp: "Mover para Cima",
    moveDown: "Mover para Baixo",
    moveBottom: "Mover para o Final",
    moveToTarget: "Mover para o Destino",
    moveToSource: "Mover para a Origem",
    moveAllToTarget: "Mover Todos para o Destino",
    moveAllToSource: "Mover Todos para a Origem",
    pageLabel: "Página {page}",
    firstPageLabel: "Primeira Página",
    lastPageLabel: "Última Página",
    nextPageLabel: "Próxima Página",
    previousPageLabel: "Página Anterior",
    rowsPerPageLabel: "Linhas por página",
    jumpToPageDropdownLabel: "Ir para a Página",
    jumpToPageInputLabel: "Ir para a Página",
    selectRow: "Linha Selecionada",
    unselectRow: "Linha Desmarcada",
    expandRow: "Expandir Linha",
    collapseRow: "Recolher Linha",
    showFilterMenu: "Mostrar Menu de Filtro",
    hideFilterMenu: "Esconder Menu de Filtro",
    filterOperator: "Operador de Filtro",
    filterConstraint: "Restrição de Filtro",
    editRow: "Editar Linha",
    saveEdit: "Salvar Edição",
    cancelEdit: "Cancelar Edição",
    listView: "Visualização de Lista",
    gridView: "Visualização de Grade",
    slide: "Deslizar",
    slideNumber: "Slide {slideNumber}",
    zoomImage: "Ampliar Imagem",
    zoomIn: "Ampliar",
    zoomOut: "Reduzir",
    rotateRight: "Rotacionar para a Direita",
    rotateLeft: "Rotacionar para a Esquerda",
  },
};
